export enum Agenda {
  BICYCLES = 'module-bicycles',
  DELICTS = 'DelictsGrid',
  DOGS = 'DogsGrid',
  EMPLOYEES = 'module-employees',
  ERRORS = 'ErrorsGrid',
  EVENTS = 'module-events',
  HISTORY = 'HistoryGrid',
  DAYPLANS = 'DayplansGrid',
  REQUESTS_HOLIDAY = 'RequestsHolidayGrid',
  REQUESTS_PAY = 'RequestsPayGrid',
  SHIFT_CYCLES = 'ShiftCyclesGrid',
  SHIFTS = 'ShiftsGrid',
  CALENDARS = 'CalendarsGrid',
  DAYS = 'DaysGrid',
  PERIODS = 'PeriodsGrid',
  WEEKS = 'WeeksGrid',
  WORK_DAY_TYPES = 'work-day-types-form',
  WORK_POSITIONS = 'work-positions-form',
  CLAIMS = 'ClaimsGrid',
  INVENTORY_CARDS = 'InventoryCardsGrid',
  JOB_RUNS = 'JobRunsGrid',
  JOBS = 'JobsGrid',
  MY_ITEMS = 'MyItemsGrid',
  OPERATIONAL_WAREHOUSE = 'OperationalWarehouseGrid',
  PROTOCOLS = 'ProtocolsGrid',
  REPAIRS = 'RepairsGrid',
  REPORTS = 'ReportsGrid',
  REQUESTS = 'requestsGrid',
  MY_REQUESTS = 'myRequestsGrid',
  ROLES_ASSIGN = 'RolesAssignGrid',
  ROLES_CREATE = 'RolesCreateGrid',
  TASKS = 'module-tasks',
  MY_TASKS = 'module-my-tasks',
  TICKETS = 'TicketsGrid',
  TRIPS = 'Trips',
  WANTED_PERSONS = 'module-person',
  WANTED_VEHICLES = 'module-vehicle'
}



// WEBPACK FOOTER //
// ./src/modules/columnSettings/_columnSettingsEnums.ts